import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=190928d8&scoped=true&"
import script from "./LayoutSidebar.vue?vue&type=script&lang=ts&"
export * from "./LayoutSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=190928d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190928d8",
  null
  
)

export default component.exports